export default function ($http) {
    return function (model) {
        return $http.post('api/users/add', model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/services/add/addUser.js